import LegalPageLayout from "@/components/LegalPageLayout";

export default function Privacy() {
  return (
    <LegalPageLayout
      title="Privacy Policy"
      description="How College Unlock collects, uses and protects your information."
      updated="June 2026"
      testid="privacy-page"
    >
      <p>
        This Privacy Policy explains how College Unlock collects, uses and protects the information
        you share with us when you use our platform and services.
      </p>

      <h2>Information We Collect</h2>
      <p>
        When you use our forms (such as admission guidance, information requests, AI counselling or
        contact), we may collect your name, mobile number, email address, preferred course, preferred
        admission year, budget range and city. We also collect basic usage information such as the
        pages you visit and the device you use.
      </p>

      <h2>How We Use Your Information</h2>
      <ul>
        <li>To provide admission guidance, college recommendations and counselling.</li>
        <li>To contact you regarding your enquiry by phone, email or messaging.</li>
        <li>To improve our platform and the quality of our recommendations.</li>
      </ul>

      <h2>Sharing of Information</h2>
      <p>
        We may share your enquiry details with our admission counsellors and, where relevant, with
        partner colleges or institutions strictly for the purpose of helping you with admissions. We
        do not sell your personal information.
      </p>

      <h2>Cookies & Analytics</h2>
      <p>
        We use standard analytics tools (such as Google Analytics) to understand how visitors use our
        platform. This helps us improve the experience for students.
      </p>

      <h2>Data Security</h2>
      <p>
        We take reasonable measures to protect your information. However, no method of transmission or
        storage is completely secure, and we cannot guarantee absolute security.
      </p>

      <h2>Your Choices</h2>
      <p>
        You may contact us to request access to, correction of, or deletion of the personal
        information you have shared with us.
      </p>

      <h2>Ownership</h2>
      <p data-testid="privacy-ownership">
        This website is owned and operated by Spiritual Mantra.
      </p>

      <h2>Contact</h2>
      <p>
        For any privacy-related questions, please reach us at hello@collegeunlock.in.
      </p>
    </LegalPageLayout>
  );
}
